import { GiftIcon } from 'lucide-react';

import { useProfileNudge } from '../hooks/use-profile-nudge';

const R = 7;
const CIRC = 2 * Math.PI * R;

/** Anel pequeno com o quanto do perfil já está preenchido. */
function ProgressRing({ percent }: { percent: number }) {
  return (
    <svg viewBox="0 0 18 18" className="size-[18px] -rotate-90" aria-hidden>
      <circle cx="9" cy="9" r={R} fill="none" strokeWidth="2.5" className="stroke-primary/20" />
      <circle
        cx="9"
        cy="9"
        r={R}
        fill="none"
        strokeWidth="2.5"
        strokeLinecap="round"
        className="stroke-primary"
        strokeDasharray={CIRC}
        strokeDashoffset={CIRC * (1 - Math.min(100, Math.max(0, percent)) / 100)}
      />
    </svg>
  );
}

/**
 * PRAT-161: chamada discreta no topo da página da loja para completar o
 * perfil. Com presente ligado: "Ganhe cupom de R$ 10"; sem presente:
 * "Completar perfil" com o anel de progresso. Some com o perfil completo e
 * respeita o "Agora não" (30 dias).
 */
export function ProfileNudgePill({ slug, onOpen }: { slug?: string; onOpen: () => void }) {
  const { showDot, percent, rewardShort } = useProfileNudge(slug);
  if (!showDot) return null;

  const text = rewardShort ? `Ganhe ${rewardShort}` : 'Completar perfil';

  return (
    <button
      type="button"
      onClick={onOpen}
      aria-label={`${text} — seu perfil está ${percent}% completo`}
      className="flex h-9 max-w-[58vw] items-center gap-1.5 rounded-full border border-primary/20 bg-primary/5 px-3 text-xs font-semibold text-gray-900"
    >
      {rewardShort ? (
        <GiftIcon className="size-4 shrink-0 text-primary" aria-hidden />
      ) : (
        <ProgressRing percent={percent} />
      )}
      <span className="truncate">{text}</span>
    </button>
  );
}
